import React, { Component } from "react";
import "./GlassGlowComponent.scss";

export interface GlassGlowComponentProps {
  /** When true, the panel is visible and glow animations run. */
  open?: boolean;
  /** Optional theme hook (reserved for future styles; matches original markup). */
  dark?: boolean;
  className?: string;
  children?: React.ReactNode;
}

export default class GlassGlowComponent extends Component<GlassGlowComponentProps> {
  render(): React.JSX.Element {
    return (
      <div className="neonedge open">
        <span className="shine shine-top" />
        <span className="shine shine-bottom" />
        <span className="glow glow-top" />
        <span className="glow glow-bottom" />
        <span className="glow glow-bright glow-top" />
        <span className="glow glow-bright glow-bottom" />
        <div className="inner">
          {this.props.children}
        </div>
      </div>
    );
  }
}
